var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembershipfront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 231,
    viewBox: "0 0 262 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275953"
  }, /*#__PURE__*/React.createElement("g", {
    id: 76
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M128.576 216.892C188.35 216.892 236.809 168.433 236.809 108.446C236.809 48.4591 188.35 0 128.576 0C68.8029 0 20.3438 48.4591 20.3438 108.446C20.3438 168.433 68.8029 216.892 128.576 216.892Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.942 51.0205H202.858C209.049 51.0205 213.746 55.717 213.746 61.9078V159.466C213.746 165.657 209.049 170.354 202.858 170.354H48.942C42.7512 170.354 38.0547 165.657 38.0547 159.466V61.9078C38.0547 55.717 43.1781 51.0205 48.942 51.0205Z",
    fill: "url(#paint0_linear_368_9594)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter0_d_368_9594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.245 61.9009L185.554 167.226C185.554 170.824 182.61 173.604 179.012 173.604H76.3036C72.7056 173.604 69.7617 170.66 69.7617 167.226V31.8081C69.7617 28.21 72.7056 25.4297 76.3036 25.4297H150.718L184.245 61.9009Z",
    fill: "url(#paint1_linear_368_9594)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M136.323 47.5086H87.0949C85.95 47.5086 84.9688 46.5273 84.9688 45.3825C84.9688 44.2376 85.95 43.2563 87.0949 43.2563H136.323C137.468 43.2563 138.449 44.2376 138.449 45.3825C138.449 46.5273 137.468 47.5086 136.323 47.5086Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M106.066 59.285H87.0949C85.95 59.285 84.9688 58.3037 84.9688 57.1588C84.9688 56.014 85.95 55.0327 87.0949 55.0327H105.903C107.048 55.0327 108.029 56.014 108.029 57.1588C108.029 58.3037 107.048 59.285 106.066 59.285Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M150.715 25.4297V54.5412C150.715 58.63 154.313 61.9009 158.402 61.9009H184.242",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M170.542 84.1543H152.695H148.271H87.7129C86.9502 84.1543 86.1875 84.9186 86.1875 85.9887C86.1875 86.9059 86.7977 87.823 87.7129 87.823H148.271H152.695H170.39C171.457 87.823 172.068 87.0587 172.068 85.9887C172.068 85.0715 171.457 84.1543 170.542 84.1543Z",
    fill: "#D5DDEA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M216.736 113.569V161.601C216.736 167.792 211.826 172.916 205.422 172.916H47.2361C41.0453 172.916 35.9219 167.792 35.9219 161.601V109.513",
    stroke: "#1676EE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M203.288 86.6714H153.335C148.425 86.6714 143.728 88.3792 140.099 91.3679L127.077 102.042C123.448 105.03 118.751 106.738 113.841 106.738H57.4838C51.7199 106.738 47.0234 111.435 47.0234 117.198C47.0234 117.625 47.0234 118.266 47.2369 118.693L57.6973 173.77C58.5512 178.893 62.8207 182.736 68.1576 182.736H188.772C193.895 182.736 198.378 179.107 199.232 173.983L213.748 98.6261C214.816 92.8622 210.973 87.7388 205.209 86.6714C204.355 86.6714 203.715 86.6714 203.288 86.6714Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_10",
    filter: "url(#filter1_d_368_9594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.708 71.941H160.812C154.407 71.941 148.43 74.0758 143.52 78.1318L126.442 92.0078C121.746 95.8504 115.555 98.1986 109.15 98.1986H35.7146C28.243 98.1986 22.2656 104.389 22.2656 111.648C22.2656 112.288 22.2656 112.928 22.4791 113.569L35.9281 185.51C36.9955 192.342 42.7593 197.252 49.3771 197.252H206.496C213.327 197.252 218.877 192.555 219.945 185.724L238.944 87.3113C240.225 79.8396 235.315 73.2219 227.843 71.7275C227.203 71.941 226.349 71.941 225.708 71.941Z",
    fill: "url(#paint2_linear_368_9594)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M233.608 64.7153C237.691 64.7153 241.001 61.4053 241.001 57.3222C241.001 53.2392 237.691 49.9292 233.608 49.9292C229.525 49.9292 226.215 53.2392 226.215 57.3222C226.215 61.4053 229.525 64.7153 233.608 64.7153Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M226.221 40.7326C229.009 40.7326 231.27 38.4721 231.27 35.6837C231.27 32.8952 229.009 30.6348 226.221 30.6348C223.432 30.6348 221.172 32.8952 221.172 35.6837C221.172 38.4721 223.432 40.7326 226.221 40.7326Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M21.7364 57.3224C24.5248 57.3224 26.7853 55.0619 26.7853 52.2735C26.7853 49.4851 24.5248 47.2246 21.7364 47.2246C18.948 47.2246 16.6875 49.4851 16.6875 52.2735C16.6875 55.0619 18.948 57.3224 21.7364 57.3224Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M10.3765 168.398C15.555 168.398 19.753 164.2 19.753 159.021C19.753 153.843 15.555 149.645 10.3765 149.645C5.19801 149.645 1 153.843 1 159.021C1 164.2 5.19801 168.398 10.3765 168.398Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1171276056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M223.705 185.072C222.984 188.138 221.902 191.383 220.64 194.088C217.214 200.76 211.805 205.989 205.133 209.415C198.281 212.841 190.166 214.284 182.052 212.481C162.938 208.514 150.677 189.761 154.644 170.647C158.611 151.533 177.184 139.091 196.297 143.239C203.149 144.681 209.1 148.107 214.149 152.795C222.624 161.27 226.23 173.532 223.705 185.072Z",
    fill: "#003B5B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M200.444 174.794H192.33V166.68C192.33 165.057 191.068 163.614 189.265 163.614C187.642 163.614 186.199 164.876 186.199 166.68V174.794H178.085C176.462 174.794 175.02 176.056 175.02 177.859C175.02 179.663 176.282 180.925 178.085 180.925H186.199V189.039C186.199 190.662 187.461 192.104 189.265 192.104C190.887 192.104 192.33 190.842 192.33 189.039V180.925H200.444C202.067 180.925 203.51 179.663 203.51 177.859C203.51 176.056 202.067 174.794 200.444 174.794Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_368_9594",
    x: 47.7617,
    y: 14.4297,
    width: 159.793,
    height: 192.175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_9594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_9594",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_368_9594",
    x: 0.265625,
    y: 60.7275,
    width: 260.883,
    height: 169.524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_9594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_9594",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_368_9594",
    x1: 125.914,
    y1: 55.166,
    x2: 125.914,
    y2: 122.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_368_9594",
    x1: 127.62,
    y1: 22.0023,
    x2: 127.62,
    y2: 175.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_368_9594",
    x1: 130.636,
    y1: 68.824,
    x2: 130.636,
    y2: 198.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipfront);
export default __webpack_public_path__ + "static/media/membershipfront.0bfce2c04ceb7827c9105293dec5e77d.svg";
export { ForwardRef as ReactComponent };